enum PubSubEventEnum {
  LOGIN = 'MIGRATION_LOGIN',
  LOGOUT = 'MIGRATION_LOGOUT',
  TRIGGER_TOKENS_REFRESH = 'MIGRATION_TRIGGER_TOKENS_REFRESH',
  TOKENS_REFRESHED = 'MIGRATION_TOKENS_REFRESHED',
}

export default PubSubEventEnum;
